import { SHGrid, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { MSFilterSliderSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/slider";
import { MSFilterTrackRecordSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/track-record";
import { MSFilterSwitchYesNoSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/switch-yes-no";
import { MSFilterSwitchDropDownSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/switch-drop-down";
import { MSFilterSwitchSelectSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/switch-select";
import {
  MSFilterCombinedSliderSkeleton
} from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/combined-slider";

export const MSFilterDialogContentSkeleton = () => {
  return (
    <SHGrid
      container
      width={"100%"}
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "15px",
        boxSizing: "border-box",
      }}
    >
      <SHStack
        height={"fit-content"}
        width={"100%"}
        p={"12px"}
        bgcolor={"#F2F1FF"}
        borderRadius={"12px"}
        gap={1.5}
        sx={{
          transition: "gap 0.3s ease-in-out",
        }}
      >
        <SHSkeleton
          delay={false}
          width={"50%"}
          height={20}
          sx={{ marginBottom: 1 }}
        />
        {Array.from({ length: 3 }).map((_, i) => (
          <MSFilterSliderSkeleton key={i} />
        ))}
        <MSFilterTrackRecordSkeleton />
      </SHStack>

      <SHStack
        height={"fit-content"}
        width={"100%"}
        p={"12px"}
        bgcolor={"#F2F1FF"}
        borderRadius={"12px"}
        gap={1.5}
        sx={{
          transition: "gap 0.3s ease-in-out",
        }}
      >
        <SHSkeleton
          delay={false}
          width={"50%"}
          height={20}
          sx={{ marginBottom: 1 }}
        />
        {Array.from({ length: 8 }).map((_, i) => (
          <MSFilterSliderSkeleton key={i} />
        ))}
      </SHStack>

      <SHStack gap={2}>
        <SHStack
          height={"fit-content"}
          width={"100%"}
          p={"12px"}
          bgcolor={"#F2F1FF"}
          borderRadius={"12px"}
          gap={1.5}
          sx={{
            transition: "gap 0.3s ease-in-out",
          }}
        >
          <SHSkeleton
            delay={false}
            width={"50%"}
            height={20}
            sx={{ marginBottom: 1 }}
          />
          <MSFilterSwitchYesNoSkeleton />
        </SHStack>

        <SHStack
          height={"fit-content"}
          width={"100%"}
          p={"12px"}
          bgcolor={"#F2F1FF"}
          borderRadius={"12px"}
          gap={1.5}
          sx={{
            transition: "gap 0.3s ease-in-out",
          }}
        >
          <SHSkeleton
            delay={false}
            width={"50%"}
            height={20}
            sx={{ marginBottom: 1 }}
          />
          <MSFilterSwitchDropDownSkeleton />
          <MSFilterSwitchYesNoSkeleton />
        </SHStack>

        <SHStack
          height={"fit-content"}
          width={"100%"}
          p={"12px"}
          bgcolor={"#F2F1FF"}
          borderRadius={"12px"}
          gap={1.5}
          sx={{
            transition: "gap 0.3s ease-in-out",
          }}
        >
          <SHSkeleton
            delay={false}
            width={"50%"}
            height={20}
            sx={{ marginBottom: 1 }}
          />
          <MSFilterSwitchSelectSkeleton />
        </SHStack>
      </SHStack>

      <SHStack
        height={"fit-content"}
        width={"100%"}
        p={"12px"}
        bgcolor={"#F2F1FF"}
        borderRadius={"12px"}
        gap={1.5}
        sx={{
          transition: "gap 0.3s ease-in-out",
        }}
      >
        <MSFilterCombinedSliderSkeleton includeDropdown />
      </SHStack>
    </SHGrid>
  );
};
